import * as React from 'react';
import {
  label
} from './style.module.scss';

const Label = ({
  children,
  classes=""
}) => {
  return (
    <p className={`${label} ${classes}`}>
      {children}
    </p >
  )
}

export default Label;
